import RouteTemplate from 'ember-route-template';

import { pageTitle } from 'ember-page-title';

import AnnouncementSummaries from 'rise-ui/components/announcement-summaries.gjs';

export default RouteTemplate(<template>
  {{pageTitle "Announcements"}}

  <h3 class="c-page-title qa-page-title">Announcements</h3>
  <AnnouncementSummaries
    @announcements={{@model.announcements}}
  />
  {{outlet}}
</template>);
